<!--近七日数据看板-->
<template>
  <Card :bordered="false" dis-hover>
    <p slot="title">
      <span>{{ $t('home.title_7daysdata') }}</span>
      <Icon class="tip-icon" type="ios-help-circle-outline" size="17" :title="$t('home.title_7daysdata_tip')" />
    </p>
    <div class="boardcard-container">
      <div class="data-top">
        <div class="data-top-item" @click="goToCustom()" v-if="customerData.type">
          <count-to
            :end="customerData.value"
            :simplify="true"
            :unit="unit"
            unit-class="color-blue"
            count-class="count-style color-blue"
          />
          <span class="count-label">{{ customerData.desc }}</span>
        </div>
        <div class="data-top-item" @click="goToCustom()" v-if="saleData.type">
          <count-to
            :end="saleData.value"
            :simplify="true"
            :unit="unit"
            unit-class="color-orange"
            count-class="count-style color-orange"
          />
          <span class="count-label">{{ saleData.desc }}</span>
        </div>
      </div>
      <div class="data-bottom">
        <div class="data-bottom-item" @click="goToProblem()" v-if="problemData.type">
          <div class="count-group">
            <count-to :end="problemData.value | filterTotalValue(0)" count-class="count-style color-red" />
            <small>/{{ problemData.value | filterTotalValue(1) }}</small>
          </div>
          <span class="count-label">{{ problemData.desc }}</span>
        </div>
        <div class="data-bottom-item" @click="goToDevice()" v-if="deviceData.type">
          <div class="count-group">
            <count-to :end="deviceData.value | filterTotalValue(0)" count-class="count-style color-red" />
            <small>/{{ deviceData.value | filterTotalValue(1) }}</small>
          </div>
          <span class="count-label">{{ deviceData.desc }}</span>
        </div>
        <div class="data-bottom-item" @click="goToProblem()" v-if="depData.type">
          <div class="count-group">
            <count-to :end="depData.value | filterTotalValue(0)" count-class="count-style color-red" />
            <small>/{{ depData.value | filterTotalValue(1) }}</small>
          </div>
          <span class="count-label">{{ depData.desc }}</span>
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import api from '../../../api/home/index';
import CountTo from '../../../components/count-to/index';
import { numberUnitRules } from '../configParams';
import { privileageAccess } from '../../../mixins/privileage';
import { getLanguage } from 'wdz-common-components/src/common/js/ovoSystem';

export default {
  mixins: [privileageAccess],
  components: { CountTo },
  data() {
    return {
      SYSTEM_NOS: ccconstants.SYSTEM_NOS,
      customerData: {}, //客流
      saleData: {}, //销售额
      problemData: {}, //问题
      deviceData: {}, //设备
      depData: {}, //门店数据
      unit: numberUnitRules,
      showPage: true, // 上面五个数据都没有，就不显示这个页面
    };
  },
  filters: {
    //解析来自后台的 14/35这种类型的数据格式
    filterTotalValue(value, index) {
      if (value) {
        return Number(value.split('/')[index]);
      }
      return '';
    },
  },
  created() {
    this.getData();
    let lang = getLanguage();
    if (lang != 'zh-CN' || lang != 'zh-TW') {
      this.unit = [
        [3, 'K+'],
        [6, 'M+'],
        [9, 'B+'],
      ];
    }
  },
  methods: {
    async getData() {
      let data = await api.getDataOfLastSevenDays();
      if (data.list) {
        let ls = data.list;
        let flag = false;
        //目前写死的５中类型的数据
        ls.forEach(item => {
          switch (item.type) {
            case 'flow':
              this.customerData = item;
              flag = true;
              break;
            case 'problem':
              this.problemData = item;
              flag = true;
              break;
            case 'sale':
              this.saleData = item;
              flag = true;
              break;
            case 'device':
              this.deviceData = item;
              flag = true;
              break;
            case 'dept':
              this.depData = item;
              flag = true;
              break;
          }
        });
        this.showPage = flag;
      }
    },
    goToCustom() {
      // if (!this.hasPageAccess("CUSTOMER_FLOW_BOOK_1")) return;
      if (!this.hasPageAccess('CUSTOMER_FLOW_BOOK')) return;
      this.$system.goRouter({
        router: {
          //路由跳转信息,必填
          // system: this.SYSTEM_NOS.Web_Angular, //系统编号，用于辨识该功能模块现在做在哪个系统里面
          // url: '/klfx/kb', //跳转路径，需要填写在相应系统里面的路由地址
          system: this.SYSTEM_NOS.Web_People_Counting, //系统编号，用于辨识该功能模块现在做在哪个系统里面
          url: '/passenger-flow/spectaculars', //跳转路径，需要填写在相应系统里面的路由地址（运营分析-看板）
        },
      });
    },
    goToDevice() {
      if (!this.hasPageAccess('DEVICE_REPORT_NEW')) return;
      this.$system.goRouter({
        router: {
          //路由跳转信息,必填
          system: this.SYSTEM_NOS.Web_Equipment, //系统编号，用于辨识该功能模块现在做在哪个系统里面
          url: '/deviceReport', //跳转路径，需要填写在相应系统里面的路由地址
        },
      });
    },
    goToProblem() {
      if (!this.hasPageAccess('PROBLEM_DATA_MANAGE')) return;
      this.$system.goRouter({
        router: {
          //路由跳转信息,必填
          system: this.SYSTEM_NOS.Web_Boss, //系统编号，用于辨识该功能模块现在做在哪个系统里面
          url: '/patrol-shop/index.html/problem/data-manage', //跳转路径，需要填写在相应系统里面的路由地址
        },
      });
    },
  },
};
</script>
<style lang="scss" type="text/scss">
.boardcard-container {
  width: 100%;
  height: 100%;
  padding: 10px 0;
  .data-top {
    display: flex;
    justify-content: space-between;
    .data-top-item {
      width: 48%;
      height: 108px;
      text-align: center;
      margin: 10px 0;
      background: #f7f7f7;
      border-radius: 8px;
      padding: 22px 0;
    }
  }
  .data-bottom {
    display: flex;
    justify-content: space-between;
    .data-bottom-item {
      width: 32%;
      height: 108px;
      text-align: center;
      margin: 10px 0;
      background: #f7f7f7;
      border-radius: 8px;
      padding: 22px 0;
      cursor: pointer;
      .count-group {
        display: flex;
        justify-content: center;
        align-items: center;
        small {
          color: #9b9b9b;
        }
      }
    }
  }
}
.tip-icon {
  margin-left: 12px;
  cursor: pointer;
}
@media screen and (min-width: 300px) and (max-width: 768px) {
  .boardcard-container {
    justify-content: space-around;
    .data-item {
      width: auto;
      min-width: 80px;
      &:not(:last-child):after {
        content: '';
        display: none;
      }
    }
  }
}
</style>
